import { useMutation, useQueryClient } from "@tanstack/react-query";
import { repostPost, unrepostPost } from "../services/postServices";
import { FEED_QUERY_KEYS } from "../queryKeys";

interface UsePostRepostMutationProps {
  postId: number;
}

export const usePostRepostMutation = ({ postId }: UsePostRepostMutationProps) => {
  const queryClient = useQueryClient();

  const repostMutation = useMutation({
    mutationFn: () => repostPost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  const unrepostMutation = useMutation({
    mutationFn: () => unrepostPost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  return {
    repostPost: repostMutation.mutate,
    isReposting: repostMutation.isPending,
    unrepostPost: unrepostMutation.mutate,
    isUnreposting: unrepostMutation.isPending,
  };
};
